import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ReportData"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.5 3.75H18.75C19.5784 3.75 20.25 4.42157 20.25 5.25V21C20.25 21.8284 19.5784 22.5 18.75 22.5H5.25C4.42157 22.5 3.75 21.8284 3.75 21V5.25C3.75 4.42157 4.42157 3.75 5.25 3.75H7.5V3C7.5 2.17157 8.17157 1.5 9 1.5H15C15.8284 1.5 16.5 2.17157 16.5 3V3.75ZM15 3H9V6H15V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21ZM12.75 15H11.25V18H12.75V15ZM15 13.5H16.5V18H15V13.5ZM9 10.5H7.5V18H9V10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ReportData.vue"]]);
